import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const updateRtb = ({ formData, slug }) => axios.patch(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings`, formData)
const updateRtbMode = ({ formData, slug }) => axios.patch(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/modes`, formData)
const getCreateDataModifierAndFilter = (slug) => axios.get(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/bid-modifier/conditions/create`)
const generateUrl = ({ slug, phoneNumberSlug }) => axios.get(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/number/${phoneNumberSlug}/url`)

export {
    updateRtb,
    updateRtbMode,
    generateUrl,
    getCreateDataModifierAndFilter,
}
